// Keep in sync with MAX_FILE_SIZE_FOR_PREVIEW_BYTES in benchling/external_files/mixins/previewable.py
const ONE_MEGABYTE = 1024 * 1024;
export const MAX_FILE_SIZE_FOR_PREVIEW_BYTES = 100 * ONE_MEGABYTE;
